import React from 'react';

export default props => {
  const { dependentValues } = props;
  if (!dependentValues || !dependentValues.options) return <div />;

  return (
    <div title={props.value}>
      <a href={props.value} target="_blank">
        {props.value}
      </a>
    </div>
  );
};
